<div class="bg-workspace min-vh-100">
  <top-bar [title]="'News'"></top-bar>
  <div class="container py-4 px-md-5">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a routerLink="/admin/news">News</a></li>
        <li class="breadcrumb-item active" aria-current="page">Open News Item</li>
      </ol>
    </nav>

    <div class="row mb-4">
      <div class="col-auto mb-3 mb-sm-0">
        <h4 class="mb-0">Open News Item</h4>
        <small class="text-muted">Preview manager-facing news content.</small>
      </div>
      <div class="col-auto ms-auto d-flex gap-2">
        <button class="btn btn-primary rounded-pill px-4 py-2" type="button" (click)="edit()">Edit</button>
      </div>
    </div>

    <div class="row g-4 align-items-start">
      <div class="card">
        <div class="card-header border-bottom border-secondary pb-4">
          <h5 class="mb-0">News details</h5>
        </div>
        <div class="card-body p-4">
          <div class="row g-3">
            <div class="col-12">
              <div class="form-floating">
                <input
                  class="form-control pe-none"
                  type="text"
                  [value]="item?.content?.title || '-'"
                  placeholder="Title"
                />
                <label>Title</label>
              </div>
            </div>
            <div class="col-12">
              <div class="form-floating">
                <input
                  class="form-control pe-none"
                  type="text"
                  [value]="item?.content?.subtitle || '-'"
                  placeholder="Subtitle"
                />
                <label>Subtitle</label>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-floating">
                <input
                  class="form-control pe-none"
                  type="text"
                  [value]="(item?.content?.type || 'NEWS') | titlecase"
                  placeholder="Type"
                />
                <label>Type</label>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-floating">
                <input
                  class="form-control pe-none"
                  type="text"
                  [value]="(item?.publicationDate || item?.creationDate) | date : 'd/MM/yyyy HH:mm'"
                  placeholder="Publication date"
                />
                <label>Publication date</label>
              </div>
            </div>
            <div class="col-12 col-lg-4">
              <div class="form-floating">
                <input
                  class="form-control pe-none"
                  type="text"
                  [value]="(item?.author?.details?.name || '') + ' ' + (item?.author?.details?.surname || '')"
                  placeholder="Author"
                />
                <label>Author</label>
              </div>
            </div>
            <div class="col-12">
              <h6 class="text-muted pt-2 mb-2">Labels</h6>
              <div class="d-flex flex-wrap gap-2" *ngIf="getLabels().length > 0; else noLabels">
                <span
                  *ngFor="let label of getLabels()"
                  class="badge badge-outline-secondary fw-lighter text-uppercase"
                >
                  {{ label }}
                </span>
              </div>
              <ng-template #noLabels>
                <span>-</span>
              </ng-template>
            </div>
            <div class="col-12">
              <div class="d-flex flex-wrap align-items-center gap-2 pt-2 mb-2">
                <h6 class="text-muted mb-0">Recipients</h6>
                <app-paginator
                  *ngIf="recipientsPage"
                  class="ms-auto"
                  [data]="recipientsPage"
                  [pageable]="recipientsPageable"
                  (newPage)="switchRecipientsPage($event)"
                ></app-paginator>
              </div>
              <div *ngIf="isAllCurrentManagersRecipient(); else recipientsList" class="small">
                All school managers
              </div>
              <ng-template #recipientsList>
                <div *ngIf="getRecipients().length > 0; else noRecipients" class="list-group">
                  <div
                    *ngFor="let recipient of getRecipients()"
                    class="list-group-item d-flex justify-content-between align-items-start gap-3"
                  >
                    <div>
                      <div class="small fw-medium">
                        {{ getRecipientLabel(recipient) }}
                      </div>
                      <div *ngIf="getRecipientEmail(recipient)" class="small text-muted">
                        {{ getRecipientEmail(recipient) }}
                      </div>
                    </div>
                    <span class="badge bg-primary fw-lighter text-uppercase">
                      {{ getRecipientTypeLabel(recipient) }}
                    </span>
                  </div>
                </div>
              </ng-template>
              <ng-template #noRecipients>
                <span>-</span>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header border-bottom border-secondary pb-4">
          <h5 class="mb-0">Preview</h5>
        </div>
        <div class="card-body pt-4 px-4 px-md-5">
          <h3 class="mb-5" [innerHTML]="item?.content?.title || 'News title preview'"></h3>
          <h4 *ngIf="item?.content?.subtitle" class="mb-4" [innerHTML]="item?.content?.subtitle"></h4>
          <div class="row g-1 mb-4">
            <div class="col-auto">
              <span class="small text-muted me-2">
                {{ item?.author?.details?.name }} {{ item?.author?.details?.surname }}
              </span>
            </div>
            <div class="col-auto">
              <span class="small text-muted me-2">
                {{ (item?.publicationDate || item?.creationDate) | date : 'd MMMM y | h:mm' }}
              </span>
            </div>
            <div class="col-auto">
              <span
                *ngFor="let label of getLabels()"
                class="badge badge-outline-secondary fw-lighter text-uppercase ms-1 ms-md-3"
              >
                {{ label }}
              </span>
            </div>
          </div>
          <div *ngIf="item?.content?.image" class="mb-5 ratio ratio-16x9">
            <img [src]="item?.content?.image" alt="Preview image" class="rounded-1 object-fit-contain" />
          </div>
          <div class="mb-0 news-copy" [innerHTML]="item?.content?.copy || '<span class=&quot;text-muted&quot;>Body preview</span>'"></div>
        </div>
      </div>

      <div class="card">
        <div class="card-header border-bottom border-secondary pb-4 d-flex align-items-center">
          <h5 class="mb-0">Recipients read status</h5>
          <app-paginator
            *ngIf="recipientsReadingPage"
            class="ms-auto"
            [data]="recipientsReadingPage"
            [pageable]="recipientsReadingPageable"
            (newPage)="switchRecipientsReadingPage($event)"
          ></app-paginator>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead>
              <tr class="table-row table-row-head text-nowrap">
                <th scope="col">Manager</th>
                <th scope="col">Email</th>
                <th scope="col">School</th>
                <th scope="col">Read at</th>
                <th scope="col">Status</th>
              </tr>
              </thead>
              <tbody class="table-body">
              <tr *ngFor="let row of getRecipientsReadingRows()" class="table-row">
                <td class="fw-medium">{{ row.managerName }}</td>
                <td>{{ row.managerEmail }}</td>
                <td>{{ row.schoolName }}</td>
                <td>
                  {{ row.readingDate ? (row.readingDate | date : 'd/MM/yyyy HH:mm') : '-' }}
                </td>
                <td>
                    <span class="badge" [ngClass]="row.readingDate ? 'bg-success' : 'bg-secondary'">
                      {{ row.readingDate ? 'Read' : 'Unread' }}
                    </span>
                </td>
              </tr>
              <tr *ngIf="getRecipientsReadingRows().length === 0">
                <td colspan="5" class="text-center text-muted pt-5">No results found</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
